/**
 * AddFeedbackScreenshotCellType enum
 *
 * Discriminates the two cell kinds in the add-feedback screenshots picker grid
 * (`FeedbackScreenshotsPickerGrid`): a filled `screenshot` cell (a collected
 * `LocalFeedbackScreenshot`) vs the trailing `add` cell that opens the picker.
 *
 * String-valued (not a Firestore round-trip — it's a pure UI cell-kind
 * discriminator), so member order is inert.
 */
export enum AddFeedbackScreenshotCellType {
  screenshot = 'screenshot',
  add = 'add',
}
